import type { createA11yApi } from './a11yApi';

import type { PublicApiKey } from '@/apilib';

export const A11yApiKey: PublicApiKey<typeof createA11yApi> = {
  name: 'A11yApi',
  public: true,
};
